'use client'
/***
 *
 * @file components/RichTextBox/index.tsx
 * @description RichTextBox component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Ingka Centres
 * @since 13 Feb 2024
 *
 */

import React, { useEffect, useState } from "react";
// import "./Modal.scss";
import Form from "../DynamicForm";

/** type of props to be passed in RichTextBox function component */
type T_Props = {
    /** id of RichText content type */
    id?: string,

    /** content of RichText content type */
    data: any,

    handleModalClose?: any
}

/**
 * Name: RichTextBox
 * 
 * Description: a functional component that takes in richtext content from Contentful and renders it on UI by parsing the richtext JSON response
 *
 * @param param0 object containing data, typeid and other props
 * @example T_Props 
 * ```
 * type T_Props = {
 *     id?: string,            // optional
 *     data: any,            
 *     handleModalClose?: any, // optional
 * }
 * ```
 * @returns an html element containing the richtext content delivered by Contentful
 */
const Modal = ({ id = "", data, handleModalClose, ...props }: T_Props) => {
    // const [contactFormContent, setContactFormContent]: any = useState();
    // const [downloadFormContent, setDownloadFormContent]: any = useState();

    // const renderData = data === 'contactForm' ? contactFormContent : downloadFormContent;
    return (
        <div className="mdl">
            <div className="modal-content">
                <span className="close" onClick={handleModalClose}>&times;</span>
                <Form id={`form`} key={`form`} frmData={data} />
            </div>
        </div>
    );
};

export default Modal;
